import type { NotificationData } from '~/core/services/signalRService';

export interface ToastNotification extends NotificationData {
  id: number;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  autoClose?: boolean;
  showTime?: string;
}

// Global state để đảm bảo shared state
const globalToasts = ref<ToastNotification[]>([]);

export const useToast = () => {
  const toasts = globalToasts;

  // Thêm toast mới
  const addToast = (notification: NotificationData, options?: {
    type?: 'success' | 'error' | 'warning' | 'info';
    duration?: number;
    autoClose?: boolean;
  }) => {
    console.log('addToast', notification);
    const toast: ToastNotification = {
      ...notification,
      type: options?.type || 'info',
      duration: options?.duration || 5000,
      autoClose: options?.autoClose !== false,
      showTime: new Date().toISOString()
    };

    console.log('Toast created:', toast);
    toasts.value.unshift(toast);
    console.log('Toasts after add:', toasts.value.length, toasts.value);

    // Giới hạn số lượng toast hiển thị
    if (toasts.value.length > 5) {
      toasts.value = toasts.value.slice(0, 5);
    }

    // Tự động xóa toast sau duration
    if (toast.autoClose) {
      setTimeout(() => {
        removeToast(toast.id);
      }, toast.duration);
    }
  };

  // Xóa toast
  const removeToast = (toastId: number) => {
    const index = toasts.value.findIndex(t => t.id === toastId);
    if (index > -1) {
      toasts.value.splice(index, 1);
    }
  };

  // Xóa tất cả toast
  const clearAllToasts = () => {
    toasts.value = [];
  };

  // Toast thành công
  const showSuccess = (title: string, message: string, url?: string) => {
    addToast({
      id: Date.now(),
      title,
      message,
      url,
      createdDate: new Date().toISOString(),
      isRead: false
    }, { type: 'success' });
  };

  // Toast lỗi
  const showError = (title: string, message: string, url?: string) => {
    addToast({
      id: Date.now(),
      title,
      message,
      url,
      createdDate: new Date().toISOString(),
      isRead: false
    }, { type: 'error', duration: 8000 });
  };

  // Toast cảnh báo
  const showWarning = (title: string, message: string, url?: string) => {
    addToast({
      id: Date.now(),
      title,
      message,
      url,
      createdDate: new Date().toISOString(),
      isRead: false
    }, { type: 'warning', duration: 6000 });
  };

  // Toast thông tin
  const showInfo = (title: string, message: string, url?: string) => {
    addToast({
      id: Date.now(),
      title,
      message,
      url,
      createdDate: new Date().toISOString(),
      isRead: false
    }, { type: 'info' });
  };

  return {
    toasts: readonly(toasts),
    addToast,
    removeToast,
    clearAllToasts,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
}; 